/* eslint-disable import/prefer-default-export */
export const INTEGRATION_STATUS = {
  NOT_INTEGRATED : 'notIntegrated',
  PENDING : 'pending',
  INTEGRATED : 'integrated',
}

export function isCompanyIntegrationDataStaleOrPending( companyIntegrationData ) {
  if ( !companyIntegrationData ) {
    return true
  }
  
  const { timestamp, integrationStatus } = companyIntegrationData
  if ( integrationStatus === INTEGRATION_STATUS.PENDING || Date.now() - timestamp > 24 * 60 * 60 * 1000 ) { // expires after 24 hours
    return true
  }

  return false
}
